'use strict';

module.exports = class AvailabilityModel {
  request() {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      const url = `${$HOST}/auth/v1/auth/check`;
      xhr.open("GET", url, true);
      xhr.onreadystatechange = function() {
        if (xhr.status === 403) {
          reject({
            status: this.status,
            statusText: xhr.statusText
          });
        }
        if (xhr.status === 200) {
          resolve(xhr.response);
        }
      }
      xhr.send();
    });
  }
}